<template>
    <vx-expandable-card>
        <template v-slot:header>Documentation</template>
        <template v-slot:content>
            <div class="mb-4">
                When the Calendly integration is connected, meeting requests scheduled via Calendly will automatically
                create new contacts in Voxie.
            </div>
            <div class="mb-4">
                A prerequisite for this integration is that
                <strong>Calendly must be configured to collect the invitee's phone number</strong>. This is done by
                adding an "Extra Question" of type "Phone Number" to the event type. Voxie will then extract the phone
                number from the invitee's responses when creating the contact.
            </div>
            <div class="mb-4">
                On top of the phone number, Voxie will collect the following contact data from Calendly:
            </div>
            <ul class="list-disc list-inside mb-4">
                <li>First name</li>
                <li>Last name</li>
                <li>Email address</li>
                <li>Time-zone</li>
                <li>
                    Contact custom attributes:
                    <ul class="list-disc list-inside pl-4 mt-1">
                        <li><code>calendly_meeting_name</code></li>
                        <li><code>calendly_meeting_status</code></li>
                        <li><code>calendly_meeting_date_time</code></li>
                        <li><code>calendly_reschedule_url</code></li>
                    </ul>
                </li>
            </ul>
            <div class="mb-4">
                Voxie Franchise Hub customers can also map Calendly event types to Voxie groups so that contacts are
                automatically attached to a group when their meeting is scheduled.
            </div>
            <div>
                The data mapping detailed above can be customized to fit your specific use case. Contact Voxie Support
                for more details.
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup lang="ts">
import { VxExpandableCard } from '@voxie/frontend-components';
</script>
